import * as Yup from 'yup'

export const validateSchema = Yup.object().shape({
    username: Yup.string()
        .required('Логин является обязательным')
        .min(3, 'Логин должно содержать минимум 3 символа')
        .max(50, 'Логин не должно превышать 50 символов'),
    password: Yup.string()
        .min(8, 'Пароль должен содержать минимум 8 символов')
        .max(20, 'Пароль должен содержать максимум 20 символов')
        .matches(
            /[A-Z]/,
            'Пароль должен содержать минимум одну заглавную букву',
        )
        .matches(/[0-9]/, 'Пароль должен содержать минимум одну цифру')
        .matches(
            /[!?#$&@]/,
            'Пароль должен содержать минимум один специальный символ (!?#$&@)',
        )
        .required('Пароль является обязательным'),
    phone: Yup.string()
        .required('Телефон является обязательным')
        .matches(/^[\d+()-\s]+$/, 'Введите корректный номер телефона'),
    email: Yup.string()
        .email('Введите корректный email')
        .required('Email является обязательным'),
    user_ad_personal_info: Yup.object().shape({
        first_name: Yup.string()
            .required('Имя является обязательным')
            .min(2, 'Имя должно содержать минимум 2 символа')
            .max(50, 'Имя не должно превышать 50 символов'),
        surname: Yup.string()
            .required('Фамилия является обязательной')
            .min(2, 'Фамилия должна содержать минимум 2 символа')
            .max(50, 'Фамилия не должна превышать 50 символов'),
    }),
    role: Yup.string().required('Роль пользователя является обязательной'),
})
